import { createFileRoute } from '@tanstack/react-router';
import { Hero } from '@/components/lobby/Hero';
import { NewGame } from '@/components/lobby/NewGame';
import { RejoinCard, readRejoinMemo } from '@/components/lobby/RejoinCard';
import { ResumeCard } from '@/components/lobby/ResumeCard';
import { useGame } from '@/store/game';

export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  const game = useGame(s => s.game);
  const resumable = game && game.phase === 'playing' ? game : null;
  // Re-read on every render: the memo lives outside React state.
  const rejoin = readRejoinMemo();

  return (
    <div className="mx-auto max-w-3xl px-4 py-6 sm:py-8">
      <div className="mb-8">
        <Hero />
      </div>

      {rejoin && (
        <div className="mb-8">
          <RejoinCard memo={rejoin} />
        </div>
      )}

      {resumable && (
        <div className="mb-8">
          <ResumeCard game={resumable} />
        </div>
      )}

      <NewGame />
    </div>
  );
}
